import state from './module-taxreturn-state';
import mutations from './module-taxreturn-mutations';
import actions from './module-taxreturn-actions';
import getters from './module-taxreturn-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
